import { render, staticRenderFns } from "./settings.vue?vue&type=template&id=56290b99&"
import script from "./settings.ts?vue&type=script&lang=js&"
export * from "./settings.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports